import type { WellKnownPropertyValues, GlobalLoggingContextProvider } from "@octopusdeploy/logging";
import { browserSessionId } from "~/openTelemetry/context/browserSessionId";
import { currentPageContext } from "~/openTelemetry/context/currentPageContext";
type PortalGlobalLoggingContext = WellKnownPropertyValues<{
    pageid?: string;
    BrowserSessionId?: string;
}>;
export const portalLoggingContextProvider: GlobalLoggingContextProvider<PortalGlobalLoggingContext> = {
    getProperties: () => ({ pageid: currentPageContext.getCurrentPage()?.Id, BrowserSessionId: browserSessionId }),
};
